import { render, staticRenderFns } from "./InsuranceSkladUsaModule.vue?vue&type=template&id=600c7e58&scoped=true"
import script from "./InsuranceSkladUsaModule.vue?vue&type=script&lang=js"
export * from "./InsuranceSkladUsaModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600c7e58",
  null
  
)

export default component.exports